import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-advance-autocomplete',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    FormlyModule,
  ],
  template: `
    <div class="field">
      @if (props.label) {
        <label [for]="field.key" class="block mb-2">
          {{ props.label }}
          <span *ngIf="props.required" class="text-red-500">*</span>
        </label>
      }
      <p-autocomplete
        styleClass="project-ac"
        [multiple]="true"
        [forceSelection]="props.forceSelection === false ? false : true"
        [suggestions]="props.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="props.field"
        [dropdown]="props.dropdown"
        [style]="{ width: '100%' }"
        (completeMethod)="props.search && props.search(field, $event)"
        (onSelect)="props.onSelect && props.onSelect($event)"
        (onUnselect)="props.onUnselect && props.onUnselect($event)"
        [placeholder]="props.placeholder || 'Keresés...'">
        <!-- Template az előlegek megjelenítéséhez a dropdown listában -->
        <ng-template let-advance pTemplate="item">
          <div class="advance-dropdown-item">
            <div class="advance-main">
              <strong>{{ advance.description }}</strong>
              <span class="advance-amount">{{
                advance.amount | currency: 'HUF' : 'symbol' : '1.0-0' : 'hu-HU'
              }}</span>
            </div>
            @if (advance.projectName) {
              <div class="advance-details">
                <small class="text-muted"
                  >Projekt: {{ advance.projectName }}</small
                >
              </div>
            }
            <div class="advance-details">
              <small class="text-muted"
                >Dátum: {{ advance.issuedDate | date: 'yyyy.MM.dd' }}</small
              >
            </div>
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
  `,
  styles: [
    `
      .advance-dropdown-item {
        padding: 0.5rem;
        border-bottom: 1px solid #e9ecef;
      }

      .advance-dropdown-item:last-child {
        border-bottom: none;
      }

      .advance-main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.25rem;
      }

      .advance-amount {
        font-weight: bold;
        color: #28a745;
      }

      .advance-details {
        margin-top: 0.25rem;
      }

      .text-muted {
        color: #6c757d !important;
        font-size: 0.875rem;
      }
    `,
  ],
})
export class FormlyAdvanceAutoCompleteComponent extends FieldType<FieldTypeConfig> {}
